import { Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { iDataSource, IDataSourceService } from '../../../services/DataSourceServices/IDataSourceService.service';
import { Single } from '../../../interfaces/single.interface';
import { PieChartOptions } from '../../charts/pie-chart/pie-chart.component';
import { EveReportingWidgetDataSource } from '../widget-menu-settings/widget-datasource/widget-datasource.component';
import { EveReportingWidget } from '../widget.component';



@Component({
  selector: 'pie-chart-widget',
  templateUrl: 'pie-chart-widget.component.html',
  styleUrls: ['./pie-chart-widget.component.css']
})
export class PieChartWidgetComponent {

  options: PieChartOptions = null;

  @Input()
  widget?: EveReportingPieChartWidget = null;

  @Output()
  isLoading: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Output()
  hasErrored: EventEmitter<boolean> = new EventEmitter<boolean>();

  widgetObservables: BehaviorSubject<EveReportingWidget>;

  results: Observable<Single[]>;
  
  constructor(
    public dataSourceService: IDataSourceService
  )
  {
  }

  ngDoCheck(): void {
    if (this.options.colourScheme != this.widget?.colourScheme) this.options.colourScheme = this.widget?.colourScheme;

    if (JSON.stringify(this.widget) !== JSON.stringify(this.widgetObservables.value)) this.widgetObservables.next(JSON.parse(JSON.stringify(this.widget)));
  }

  ngOnInit(): void {
    this.isLoading.emit(false);
    this.hasErrored.emit(false);

    this.options = {
      width: null,
      height: null,
      chartHeader: null,
      colourScheme: this.widget?.colourScheme
    }

    //service import
    this.widgetObservables = new BehaviorSubject<EveReportingWidget>(JSON.parse(JSON.stringify(this.widget)));
    this.results = this.dataSourceService.SingleResults(this.widgetObservables, staticResults);
  }

  public onSelect(data) {
    //this.select.emit(data);
    alert("hi");
  }


}



export interface EveReportingPieChartWidget extends EveReportingWidget, iDataSource {
  colourScheme: any,

  dataSource: EveReportingWidgetDataSource
}

const staticResults: Single[] = [
  {
    name: "User1",
    value: 10
  },
  {
    name: "User2",
    value: 6
  },
  {
    name: "User3",
    value: 12
  },
];
